import { forwardRef } from 'react';

import './Backdrop.scss';

export const Backdrop = forwardRef<HTMLDivElement>((props, ref) => (
    <div
      className="backdrop"
      ref={ref}
      {...props}
    />
));
